/** Keyboard navigation helpers for the combobox pattern. */

export type ListKey = "ArrowDown" | "ArrowUp" | "Home" | "End";

export function nextIndex(current: number, total: number, key: ListKey): number {
  if (total === 0) return -1;
  switch (key) {
    case "ArrowDown":
      return current < 0 ? 0 : Math.min(current + 1, total - 1);
    case "ArrowUp":
      return current <= 0 ? total - 1 : current - 1;
    case "Home":
      return 0;
    case "End":
      return total - 1;
  }
}
